import {  Component,  OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogResult } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { Claim } from 'src/app/feature-module/claims-data/models/Claim';
import { ClaimDataService } from 'src/app/feature-module/claims-data/service/claim-data.service';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { PortalMessageSearchResultItem } from '../../models/PortalMessageSearchResultItem';
import { PortalMessageService } from '../../service/portal-message.service';
import { ComposeEmailMessageComponent } from '../compose-email-message/compose-email-message.component';

import { ComposePortalMessageComponent } from '../compose-portal-message/compose-portal-message.component';
import { ComposeSmsMessageComponent } from '../compose-sms-message/compose-sms-message.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-thread-messages',
  templateUrl: './thread-messages.component.html',
  styleUrls: ['./thread-messages.component.scss']
})
export class ThreadMessagesComponent implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute,
    private messageService: PortalMessageService,
    private claimDataService: ClaimDataService,
    private customDialogService: CustomDialogService,
    private translateService: TranslateService,
    private authService: AuthService) { }
  

  claimIdentifier: string;
  messages$: Observable<PortalMessageSearchResultItem[]>;
  claim: Claim;
  userDisplayName: string;
  threadId:string;

  @ViewChild("messageListDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;


  ngOnInit(): void {
    this.claimIdentifier = this.activatedRoute.snapshot.paramMap.get('id');
    this.claimDataService.getClaimData(this.claimIdentifier).subscribe(r => this.claim = r);
    this.threadId = this.activatedRoute.snapshot.paramMap.get('threadId');
    this.userDisplayName = this.authService.getLoggedUserInfo().getDisplayName();

    this.loadMessages();
  }

  loadMessages() {
    this.messages$ = this.messageService.getThreadPortalMessages(this.threadId);
  }

  composePortalMessage() {

    const dialogSettings: CustomDialogSettings = {
      content: ComposePortalMessageComponent,
      appendTo: this.containerRef,
      title: this.translateService.instant('claims-center.claimMessages.composePortalMessage'),
      minHeight: '70vh',
      minWidth: '60vw',
      maxHeight: '95vh',
      maxWidth: '95vw',
      dialogInputs: {
        claimIdentifier: this.claimIdentifier,
        threadId: this.threadId,
      },
      resultCallback: (r: DialogResult) => {
        if (r['text'] == 'OK') {
          this.loadMessages();
        }
      }
    };

    this.customDialogService.showDialog(dialogSettings);

  }

  composeSmsMessage() {
    const dialogSettings: CustomDialogSettings = {
      content: ComposeSmsMessageComponent,
      appendTo: this.containerRef,
      title: this.translateService.instant('claims-center.claimMessages.composeSmsMessage'),
      minHeight: '70vh',
      minWidth: '60vw',
      maxHeight: '95vh',
      maxWidth: '95vw',
      dialogInputs: {
        claimIdentifier: this.claimIdentifier,
        threadId: this.threadId,
      },
      resultCallback: (r: DialogResult) => {
        if (r['text'] == 'OK') {
          this.loadMessages();
        }
      }
    };

    this.customDialogService.showDialog(dialogSettings);
  }

  composeEmailMessage() {

    const dialogSettings: CustomDialogSettings = {
      content: ComposeEmailMessageComponent,
      appendTo: this.containerRef,
      title: this.translateService.instant('claims-center.claimMessages.composeEmailMessage'),
      minHeight: '70vh',
      minWidth: '60vw',
      maxHeight: '95vh',
      maxWidth: '95vw',
      dialogInputs: {
        claimIdentifier: this.claimIdentifier,
        threadId: this.threadId,
      },
      resultCallback: (r: DialogResult) => {
        if (r['text'] == 'OK') {
          this.loadMessages();
        }
      }
    };

    this.customDialogService.showDialog(dialogSettings);
  }

  threadChangeEventHandler(){
    this.loadMessages();
  }
}

